import React from "react";
import { ThemeProvider } from "@UI/Contexts/ThemeProvider";
import { CSSIsolation } from "@UI/Contexts/CSSIsolation";
import { CreateRequestCTA } from "./CreateRequestCTA/CreateRequestCTA";

export const SidebarCTA = () => (
  <CSSIsolation>
    <ThemeProvider>
      <CreateRequestCTA />
    </ThemeProvider>
  </CSSIsolation>
);
